import axios, { AxiosPromise } from 'axios';
import { IPrinter } from '../../../@types/model/masterData/printer/printer';


export default class PrinterHttpService {
    public static getPrinterData() : AxiosPromise<Array<IPrinter>> {
        return axios.get(`${API_URL}/v1/Printer/GetAllWeb`);
    }

    public static addOrUpdatePrinter(data : IPrinter) : AxiosPromise<IPrinter> {
        return axios.post(`${API_URL}/v1/Printer/PostPrinter`, data);
    }

    public static deletePrinter(printerId : number) : AxiosPromise<IPrinter> {
        return axios.delete(`${API_URL}/v1/Printer/Delete`, {
            params : { printerId },
        });
    }
}
